interface MaskedPhoneNumberProps {
  phone?: string;
  maskedClassName?: string;
}

const MaskedPhoneNumber = ({ phone, maskedClassName = "masked-phone-part" }: MaskedPhoneNumberProps) => {
  if (!phone?.trim()) return null;

  return (
    <>
      {phone.split(/(\*+)/).map((part, index) =>
        part.includes("*") ? (
          <span className={maskedClassName} key={`${part}-${index}`}>
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  );
};

export default MaskedPhoneNumber;
